import axios from "axios";
import { create } from "zustand";
import paymentStore from "./paymentStore";
import Cookies from "js-cookie";

const couponStore = create((set) => ({
  coupon: null,
  isLoading: true,
  copyCouponCode: null,

  isCouponError: false,

  applyCouponCode: {
    couponCode: "",
    isCouponErrorMessage: "",
    isCouponError: false,
  },

  setCouponNull: () => {
    set({ coupon: null, copyCouponCode: null });
    const { clearApplyCouponCode } = couponStore.getState();
    clearApplyCouponCode();
  },

  setApplyCouponCode: ({ name, value }) => {
    set((state) => {
      return {
        applyCouponCode: {
          ...state.applyCouponCode,
          [name]: value,
        },
      };
    });
  },

  clearApplyCouponCode: () => {
    set({
      applyCouponCode: {
        couponCode: "",
        isCouponErrorMessage: "",
        isCouponError: false,
      },
    });
  },

  fetchAllCoupon: async () => {
    // Fetch Category
    const res = await axios.get("/site/fetch-all-coupon");
    // set category to state

    if (res.data.coupon != "") {
      set({ coupon: res.data.coupon });
    }

    set({ isLoading: false });
  },

  setCopyCouponCode: ({ code }) => {
    set({ copyCouponCode: code });
  },

  checkCoupon: ({ couponName }) => {
    const { coupon } = couponStore.getState();
    const { usedCouponByUser } = paymentStore.getState();
    set({ copyCouponCode: null });
    let flag = false;
    if (coupon) {
      coupon.map(async (item) => {
        if (item.couponName === couponName) {
          let f = true;
          if (usedCouponByUser) {
            usedCouponByUser.map((u) => {
              if (u === item._id) {
                f = false;
              }
            });
          }
          flag = true;
          if (f) {
            if (item.usedTotalNoOfVoucher < item.totalNoOfVoucher) {
              set({ copyCouponCode: item });
            }
          } else {
            set((state) => {
              return {
                applyCouponCode: {
                  ...state.applyCouponCode,
                  isCouponErrorMessage: "Already used",
                  isCouponError: true,
                },
              };
            });
          }
        }
      });
    }
    return flag;
  },

  usedCoupon: async ({ _id }) => {
    try {
      await axios.put(`/site/used-coupon-by-user/${_id}`);
    } catch (error) {
      console.log(error);
    }
  },
}));

export default couponStore;
